import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["as", "className"];
var TableHead = function TableHead(props, context) {
  var _props$as = props.as,
    As = _props$as === void 0 ? 'thead' : _props$as,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var finalClasses = classnames('C-TableHead', className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps));
};
TableHead.displayName = 'Table.Head';

export { TableHead as default };
